<template>
    <v-card flat rounded>
        <v-card-title class="d-flex justify-space-between">
            {{ name }}
            <v-menu hover location="start">
                <template v-slot:activator="{ props }">
                    <v-btn-icon icon="$fa-gear" size="small" v-bind="props" />
                </template>
                <v-list density="compact">
                    <v-list-item @click.stop="editExtension()">
                        <template #append>
                            <v-icon size="small">$oss-edit</v-icon>
                        </template>
                        <v-list-item-title>Editer</v-list-item-title></v-list-item
                    >
                    <v-list-item @click.stop="removeExtensionDialog()">
                        <template #append>
                            <v-icon size="small">$oss-trash</v-icon>
                        </template>
                        <v-list-item-title>Supprimer</v-list-item-title></v-list-item
                    >
                </v-list>
            </v-menu>
        </v-card-title>
        <v-card-subtitle v-text="url" />
        <v-card-text>
            <v-chip label variant="flat" rounded="pill" v-text="extensionType" size="small">
            </v-chip>
        </v-card-text>
        <oss-dialog
            v-model="removeDialog"
            title="Supprimer l'extension"
            @valid="removeExtension"
            validTitle="Supprimer"
            :error="true"
            width="60vw"
        >
            Voulez-vous supprimer l'extension <i>{{ name }}</i> ?
        </oss-dialog>
        <oss-dialog
            v-model="editDialog"
            title="Ajouter une extension"
            :actions="dialogAction"
            width="60vw"
        >
            <ExtensionItemEdition
                v-if="editDialog"
                :actions="dialogAction"
                v-bind.sync="$props"
                @updated="updateExtensionItem"
            />
        </oss-dialog>
    </v-card>
</template>

<script lang="ts">
import DELETE_EXTENSION from "@/graphql/extension/DeleteExtension.gql";

import ExtensionItemEdition from "./ExtensionItemEdition.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Emit } from "vue-facing-decorator";

@Component({
    components: {
        ExtensionItemEdition,
    },
})
export class ExtensionTableItem extends Vue {
    @Prop({ default: null }) id: any;
    @Prop({ default: "" }) name: string;
    @Prop({ default: "" }) url: string;
    @Prop({ default: "" }) type: string;
    @Prop({ default: "" }) displayIn: string;
    @Prop({ default: null }) companyScope: any;

    removeDialog: boolean = false;
    editDialog: boolean = false;

    dialogAction = {
        action: {
            title: "",
            function: () => {},
            display: true,
            disabled: false,
        },
    };

    get extensionType() {
        switch (this.type) {
            case "CARD":
                return "Indicateur";
            case "DIALOG":
                return "Dialogue";
            case "FULL_PAGE":
                return "Pleine page";
            default:
                return this.type;
        }
    }

    // --- REMOVE ---
    removeExtensionDialog() {
        this.removeDialog = true;
    }

    @Emit("removed")
    async removeExtension() {
        if (!this.id) {
            return;
        }
        await this.$apollo.mutate({
            mutation: DELETE_EXTENSION,
            variables: {
                id: this.id,
            },
        });
        return { id: this.id };
    }

    editExtension() {
        this.editDialog = true;
    }

    updateExtensionItem() {
        this.editDialog = false;
    }
}

export default toNative(ExtensionTableItem);
</script>
